<template>
  <PlaceholderPantalla
    titulo="Configuración de Inventario"
    subtitulo="Ajustes y personalización del módulo de inventario"
    descripcion="Configura el comportamiento del módulo de inventario según las necesidades de tu negocio: métodos de valuación, unidades de medida personalizadas, categorías de productos, niveles de alerta, permisos de usuarios, y integración con otros módulos del sistema."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Seleccionar método de valuación (PEPS, UEPS, Promedio Ponderado)',
  'Gestión de Categorías de Productos (crear, editar, eliminar)',
  'Gestión de Categorías de Materias Primas',
  'Configurar Unidades de Medida y sus conversiones',
  'Definir Almacenes y Ubicaciones físicas',
  'Configurar Niveles de Alerta (stock mínimo global)',
  'Configurar días de alerta para productos próximos a vencer',
  'Permisos por Usuario (quién puede crear, editar, eliminar)',
  'Configurar autorización de ajustes de inventario',
  'Integración con Módulo de Ventas (descuento automático)',
  'Integración con Finanzas (generación de movimientos)',
  'Prefijos y formatos de folios',
  'Configuración de impresión de etiquetas',
  'Respaldo y restauración de datos de inventario',
  'Auditoría: Log de cambios en inventario'
]

const datosManejados = [
  'Método de valuación de inventario',
  'Catálogo de categorías de productos',
  'Catálogo de categorías de materias primas',
  'Unidades de medida configuradas',
  'Factores de conversión entre unidades',
  'Almacenes y ubicaciones físicas',
  'Niveles de stock mínimo por defecto',
  'Días de alerta de vencimiento',
  'Matriz de permisos por usuario',
  'Configuración de autorizaciones',
  'Parámetros de integración con Ventas',
  'Parámetros de integración con Finanzas',
  'Prefijos de folios',
  'Plantillas de etiquetas',
  'Log de configuración (quién cambió qué)',
  'Parámetros de auditoría'
]
</script>
